<script setup lang="ts">
import i18n from '@/lang/i18n';
const props = defineProps<{
  operationOfficeId: number
  deliveryPlanIds: string[]
}>()

function queryParams() {
  return {
    operation_office_id: props.operationOfficeId,
    delivery_plan_ids: props.deliveryPlanIds.join(",")
  }
}
</script>
<template>
  <div class="d-flex justify-content-end bd-highlight mb-3">
    <router-link :to="{ name: 'Every24HoursReportPreview', query: queryParams() }">
      <v-btn
        class="exec-btn"
      >
        {{ i18n.global.t('common.previewBtn') }}
      </v-btn>
    </router-link>
  </div>
</template>
